import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { ColumnButton } from 'lib/components/ColumnButton';
import { UserNoticeModel } from 'lib/model/objects/userNoticeModel';
import { ColumnService } from 'lib/services/directory';
import { ESnapshotExists, EUser } from 'lib/types';
import React, { useState } from 'react';
import { useAppDispatch } from 'redux/hooks';
import ToastActions from 'redux/toast';
import { logAndCaptureException } from 'utils';

type ConfirmNoticeButtonProps = {
  disabled: boolean;
  notice: UserNoticeModel;
  user: ESnapshotExists<EUser>;
};

export const ConfirmNoticeButton = ({
  disabled: externallyDisabled,
  notice,
  user
}: ConfirmNoticeButtonProps) => {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const disabled = externallyDisabled;

  const handleClick = async () => {
    setIsLoading(true);

    try {
      await notice.confirm(user);
    } catch (e) {
      logAndCaptureException(
        ColumnService.WEB_PLACEMENT,
        e,
        'Failed to confirm notice using button',
        {
          noticeId: notice.id,
          userId: user.id
        }
      );

      dispatch(
        ToastActions.toastError({
          headerText: 'Failed to confirm notice',
          bodyText: 'Please refresh the page and try again.'
        })
      );
    }

    setIsLoading(false);
  };

  return (
    <ColumnButton
      type="button"
      id="confirm-notice"
      primary
      loading={isLoading}
      startIcon={<CheckCircleIcon className="h-6 w-6" />}
      disabled={disabled}
      onClick={handleClick}
      buttonText="Confirm notice"
      size="xl"
      fullWidth
    />
  );
};
